import React, { useState } from "react";
import SaveChanges from "./saveChanges";
import { useParams } from "react-router-dom";
import WhiteLoading from "./whiteLoading";
import Info from "./info";

const DeleteDocker = ({ updateDeleteDocker, dockerExistingName, updateAssessmentInformation }) => {
    const [text, setText] = useState("Are you sure you want to delete " + dockerExistingName + "?");
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);
    const { courseCode, assessmentCode } = useParams();

    const resetForm = () => {
        updateDeleteDocker(false);
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (requestLifeCycle) {
            return;
        }

        const url = process.env.REACT_APP_EVALUATION_API_URL + `/delete-docker-from-eval/${courseCode}/${assessmentCode}`

        const urlOptions = {
            method: "POST",
            credentials: "include"
        }

        try {
            setRequestLifeCycle(true)
            const res = await fetch(url, urlOptions);
            const data = await res.json();
            if (res.status === 200) {
                setText("Dockerfile deleted")            
                updateDeleteDocker(false);
                updateAssessmentInformation((prev) => {
                    return {
                        ...prev,
                        dockerUuid: "",
                        dockerAuthor: ""
                    }
                })
            } else {
                setText("Status Code: " + res.status + " Error: " + data.detail)
            }

        } catch (error) {
            setText("Error: " + error.message)
            console.log(error);
        } finally {
            setRequestLifeCycle(false)
        }
    }

    return (
        <>
            <div className="black-back" onClick={ () => {updateDeleteDocker(false)} }>

            </div>
            <div className="add-a-course-form-container">
                <div className="add-a-course-form-content-container">
                    <form className="form-width">
                        <div className="add-course-title">
                            Delete Current Dockerfile
                        </div>
                        <div className="account-settings-content">
                            <div className="required-container">
                                {dockerExistingName}
                            </div>   
                            <div className="banner">
                                {
                                    requestLifeCycle 

                                    ?
                                    
                                    <>
                                        <WhiteLoading />
                                    </>

                                    :

                                    <div className="banner-info">
                                        <Info />
                                        { text }
                                    </div>

                                }
                            </div>
                            <SaveChanges left="Cancel" right={{ small : "Delete", large : "Delete" }} resetForm={resetForm} submitForm={submitForm}/> 
                        </div>
                    </form> 
                </div>
            </div>
        </>
    );
}

export default DeleteDocker;